import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { SiteSettingsContext } from '@namespace/cms/src/store/siteSettings/context';
import { getAvailableLanguageFromPath } from '../../utils/language';

const useHiddenLanguageInUrl = () => {
  const location = useLocation();
  const [settings] = useContext(SiteSettingsContext);

  const { siteConfig = {}, otherSettings = {} } = settings || {};
  const { languages = [], defaultLanguage } = siteConfig;
  const { hiddenLanguageInUrl } = otherSettings || {};

  const languageFromPath = getAvailableLanguageFromPath(
    location.pathname,
    languages
  );

  const lang = languageFromPath || hiddenLanguageInUrl || defaultLanguage;

  return lang === hiddenLanguageInUrl;
};

export default useHiddenLanguageInUrl;
